import { Fragment, ReactNode } from 'react'

import { foldSearchText } from '../../utils/foldSearchText'
import * as Styled from './styles'

interface FoldedTextIndex {
  folded: string
  indexMap: number[]
}

const buildFoldedTextIndex = (text: string): FoldedTextIndex => {
  const indexMap: number[] = []
  let folded = ''

  for (let index = 0; index < text.length; index += 1) {
    const normalizedCharacter = text[index]
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .replace(/\u2212/g, '-')

    for (const character of normalizedCharacter) {
      folded += character.toLowerCase()
      indexMap.push(index)
    }
  }

  return { folded, indexMap }
}

export const highlightSearchMatch = (text: string, term: string): ReactNode => {
  const trimmedTerm = term.trim()

  if (!trimmedTerm) {
    return text
  }

  const { folded, indexMap } = buildFoldedTextIndex(text)
  const foldedTerm = foldSearchText(trimmedTerm)
  const matchStart = folded.indexOf(foldedTerm)

  if (matchStart === -1) {
    return text
  }

  const matchEnd = matchStart + foldedTerm.length - 1
  const originalStart = indexMap[matchStart] ?? 0
  const originalEnd = (indexMap[matchEnd] ?? originalStart) + 1

  return (
    <Fragment>
      {text.slice(0, originalStart)}
      <Styled.HighlightMark>{text.slice(originalStart, originalEnd)}</Styled.HighlightMark>
      {text.slice(originalEnd)}
    </Fragment>
  )
}
